<template>
    <div class="mylistpage newlist">
       <div class="bannerboxf">
            <div class="bannerbox"></div>
       </div>
       <div class="pagebody">
           <div class="listnavsf">
                <div class="listnavs">
                    <p class="navs" v-for="data,index in navs" :key="index" :class="cknavkey==data.key?'ckednav':''" @click="cknavkey=data.key">
                        {{data.name}}
                    </p>
                </div>
           </div>
           <div class="listboxf">
               <router-link  v-for="data,index in imglists[cknavkey]" :key="index"  :to="{ name:'Home',query: { a: data.name}}" :class="nowindex==index?'cklist':''" :style="{'order':data.order==-1?'':data.order}">
                   <span>{{data.chname}}</span>
                   <i class="iconfont icon-back"></i>
               </router-link >
           </div>
       </div>
    </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
    data(){
        return {
            imglists:{
                'A':[],
                'B':[],
                'C':[],
                'XZ':[]
            },
            audiolist:[],
            alldatas:alldatas,
            cknavkey:'XZ',
            nowindex:-1,
            navs:[
                {
                    name:'序章',
                    key:'XZ'
                },
                {
                    name:'第一单元',
                    key:'A'
                },
                {
                    name:'第二单元',
                    key:'B'
                },
                {
                    name:'第三单元',
                    key:'C'
                },
            ]
        }
    },
    components:{

    },
    computed:{

    },
    methods:{


    },
    created(){
        let imglists={
            'XZ':[],
            'A':[],
            'B':[],
            'C':[],
        };
        const files=require.context("@/assets/img/audioimg",true,/\.*\.jpg|jpeg|png$/).keys();
        files.forEach(e => {
            let nn=e.slice(2).split("-");
            for(let key  in this.alldatas){
                let chname;
                let describe;
                let order;
                this.alldatas[key].forEach((item,index)=>{
                    if(nn[0]==item.number){
                        chname=item.name;
                        describe=item.describe;
                        order=item.ordernum?item.ordernum:item.order
                    }
                })

                if(!chname){
                    // console.log(nn[0])
                }else{
                    imglists[key].push({
                        img:require("@/assets/img/audioimg"+e.slice(1)),
                        name:nn[0],
                        chname:chname,
                        describe:describe,
                        order:order
                    });
                }
            }
        });
        this.imglists=imglists
        let query=this.$route.query;
        if(query.nowkey){
            this.cknavkey=query.nowkey;
            this.nowindex=query.nowindex
        }
    },
    mounted(){

    },
}
</script>

<style scoped>
    *{
        margin: 0;
        padding: 0;
    }
     .newlist .cklist span{
        color: #681f00 !important;
    }
    .mylistpage{
        width: 100%;
        height: 100vh;
        overflow: auto;
     /*   background-image: url(../assets/img/bg.png);
        background-size: cover; */
        background-color: #f3d3ae;
    }
    .bannerboxf{
        width: 100%;
        height: 32.9vw;
        position: relative;
        background-image: url(../assets/img/bannerimg.jpg);
        background-size: cover;
    }
    .bannerbox{
        color: #f3d3ae;
        width: 100%;
        letter-spacing: 3px;
        height: 40vw;
        font-size: 24px;
        line-height: 40vw;
        text-align: center;
        position: absolute;
    }
    .pagebody{
        width: 100%;
        z-index: 2;
        background-color: #f3d3ae;
        border-radius: 4.6vw 4.6vw 0 0;
        position: relative;
    }
    .listnavsf{
        width: 100%;
        height: 15vw;
        border-bottom: 2px solid rgba(104, 31, 0, 0.5);
        overflow: hidden;
    }
    .listnavs{
        display: flex;
        height: 100%;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: center;
        overflow-x: auto;
        transform: translateY(3px);
    }
    .navs{
        height: 7.6vw;
        line-height: 7.6vw;
        font-size: 3.4vw;
        color: #333333;
        border-radius: 3.5vw;
        margin-left: 5vw;
        text-align: center;
        padding-left: 3vw;
        padding-right: 3vw;
    }
    .ckednav{
        background-color: #681f00;
        color: #f3d3ae;
    }
    .listboxf{
        display: flex;
        flex-direction: column;
    }
    .listboxf>a{
        width: 92%;
        margin-left: 4%;
        height: 12.6vw;
        line-height: 12.6vw;
        background-image: url(../assets/img/yinpinwenjianimg.png);
        background-size: auto 4.9vw;
        background-repeat: no-repeat;
        background-position: 0 center;
        border-bottom: 1px solid rgba(104, 31, 0, 0.5);
    }
    .listboxf span{
        color: #333333;
        font-size: 3.5vw;
        margin-left: 7.2vw;
    }
    .listboxf i{
        float: right;
        font-size: 2.5vw;
        color: #666666;
        margin-right: .5vw;
    }
</style>



// WEBPACK FOOTER //
// src/view/newlist.vue